import { Box, HStack, Link, Text, useColorMode } from '@chakra-ui/react'
import { useMemo } from 'react'
import { truncate } from '../../../../utils/stringUtils'

export const NFTDetails: React.FC<{
  hostWallet?: string
  isCreatorUser: boolean
  nftMint: string
  type?: 'NFT' | string
  holdersOnly?: boolean
}> = ({ isCreatorUser, hostWallet, nftMint, type, holdersOnly }) => {
  const nftMintDisplay = useMemo(() => {
    if (!nftMint) {
      return ''
    }
    return nftMint.slice(0, 8) + '..' + nftMint.slice(-8)
  }, [nftMint])
  const { colorMode } = useColorMode()
  const isDarkMode = colorMode === 'dark'
  return (
    <Box
      mt='2.5rem'
      p={['0.875rem', '1.875rem', '2.875rem', '2.875rem']}
      borderRadius='1.875rem'
      border={isDarkMode ? '2px solid #494949' : '2px solid #E5E5E5'}
    >
      <Text fontWeight='600' fontSize='1.25rem'>
        Details
      </Text>
      {isCreatorUser && !!hostWallet && (
        <HStack justify='space-between' p='.75rem 0'>
          <Text color='#7B7B7B' textAlign='left'>
            Raffle Host
          </Text>
          <Link
            isExternal
            href={`https://solscan.io/account/${hostWallet}`}
            color='#BDBDBD'
            wordBreak='break-all'
          >
            {truncate(hostWallet, 15)}
          </Link>
        </HStack>
      )}
      {type === 'NFT' && (
        <HStack justify='space-between' p='.75rem 0'>
          <Text color='#7B7B7B' textAlign='left'>
            Token ID
          </Text>
          <Link
            isExternal
            href={`https://solscan.io/token/${nftMint}`}
            color='#BDBDBD'
            wordBreak='break-all'
          >
            {nftMintDisplay}
          </Link>
        </HStack>
      )}
      {holdersOnly && (
        <HStack justify='space-between' p='.75rem 0'>
          <Text color='#7B7B7B' textAlign='left'>
            Holders only
          </Text>
          <Text color='#BDBDBD' wordBreak='break-all'>
            True
          </Text>
        </HStack>
      )}
      <HStack justify='space-between' p='.75rem 0'>
        <Text color='#7B7B7B' textAlign='left'>
          Chain
        </Text>
        <Text color='#BDBDBD' wordBreak='break-all'>
          Solana
        </Text>
      </HStack>
    </Box>
  )
}
